<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>

            <p v-if="is_spam">
                Marking the conversation as spam will mark <b>all</b> conversations with <b>every team member in your organization</b> as spam.  

                <ul>
                    <li>Future messages from this number will be automatically marked as spam.</li>
                    <li>Phone calls from this number will  not ring.</li>
                    <li>You will not be notified of messages or calls from this number.</li>
                </ul>
            </p>

            <p v-if="!is_spam">
                Marking the conversation as <b>not</b> spam will remove the spam designation from <b>all</b> conversations with <b>every team member in your organization</b>.  

                <ul>
                    <li>All (old) conversations from this nubmer will be archived.</li>
                </ul>
            </p>

            <v-textarea
                label="Notes"
                v-model="notes"
                :rows="1"
                auto-grow
                autofocus
            />    

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            is_spam: true,
            conversation_id: null,
            notes: '',
        }
    },

    methods: {

        showDialog(is_spam, conversation_id)
        {
            this.is_spam = is_spam;
            this.conversation_id = conversation_id;
            this.notes = '';

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /conversations/change-spam-designation',
            
                {
                    'conversation_id' : this.conversation_id,
                    'is_spam' : this.is_spam,
                    'notes' : this.notes,   
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.$emit('ok', this.is_spam);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to change spam designation.');
                },
            );
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        title() {
            if ( this.is_spam )
            {
                return 'Block (spam) conversation';
            }
            else
            {
                return 'Unblock conversation';
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>